import { destinations, NavigationProps } from "../navigation";
import styles from "../styles/SideBar.module.css";

/** Provides the desktop activity-bar shortcuts without a dead-end Settings page. */
export default function Sidebar({ active, navigateCallback }: NavigationProps) {
	return (
		<nav className={styles.sidebar} aria-label="Activity bar" data-editor-navigation>
			{destinations.map(({ Icon, name, label }) => (
				<button
					key={name}
					type="button"
					aria-label={label}
					title={label}
					aria-current={active === name ? "page" : undefined}
					className={`${styles.iconContainer} ${active === name ? styles.active : ""}`}
					onClick={() => navigateCallback(name)}>
					<Icon
						fill={active === name ? "rgb(225, 228, 232)" : "rgb(106, 115, 125)"}
						className={styles.icon}
					/>
				</button>
			))}
		</nav>
	);
}
